import React from 'react'
import './Dashboard.scss'
import LandingPage from '../../component/Layout/Dashboard/LandingPage'
const Dashboard = () => {
  return (
<div className="h-full min-h-[0] flex flex-col">
      <LandingPage/>
    </div>
  )
}

export default Dashboard
